/*
  Druckdateien in Originalqualität hochladen.

  Shopify komprimiert hochgeladene Bilder: JPG wird beim Speichern neu kodiert (getestet: 5,5 MB → 1,6 MB),
  und wer den Link im Browser öffnet, bekommt eine stark komprimierte WebP-Version. PDF- und ZIP-Dateien
  speichert Shopify dagegen Byte für Byte unverändert.

  Darum verpackt dieses Skript Bilddateien direkt vor dem Absenden des Warenkorb-Formulars in eine ZIP-Datei
  (ohne Kompression). Die Bestellung enthält dann einen Link auf «motiv.png.zip» mit dem Original darin.
  PDF, AI, EPS und ZIP bleiben unverändert. Klappt das Verpacken nicht (sehr alte Browser), wird die Datei
  wie bisher hochgeladen. Läuft nach den Formular-Prüfungen des Konfigurators: Hat dieser das Absenden
  abgebrochen (e.defaultPrevented), passiert nichts.
*/
(function () {
  'use strict';
  if (window.__ssUploadOriginal) return;
  window.__ssUploadOriginal = true;

  var IMAGE_FILE = /\.(jpe?g|png|tiff?|gif|webp|bmp|heic|heif|svg)$/i;
  var crcTable = null;

  function crc32(bytes) {
    if (!crcTable) {
      crcTable = new Uint32Array(256);
      for (var n = 0; n < 256; n++) {
        var c = n;
        for (var k = 0; k < 8; k++) c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1;
        crcTable[n] = c >>> 0;
      }
    }
    var crc = 0xFFFFFFFF;
    for (var i = 0; i < bytes.length; i++) crc = crcTable[(crc ^ bytes[i]) & 0xFF] ^ (crc >>> 8);
    return (crc ^ 0xFFFFFFFF) >>> 0;
  }

  // ZIP mit genau einer Datei, Methode «store» (keine Kompression), Dateiname als UTF-8
  function zipStore(file, bytes) {
    var name = new TextEncoder().encode(file.name);
    var crc = crc32(bytes);
    var size = bytes.length;
    var d = new Date(file.lastModified || Date.now());
    var dosTime = (d.getHours() << 11) | (d.getMinutes() << 5) | (d.getSeconds() >> 1);
    var dosDate = (Math.max(d.getFullYear() - 1980, 0) << 9) | ((d.getMonth() + 1) << 5) | d.getDate();

    var local = new DataView(new ArrayBuffer(30));
    local.setUint32(0, 0x04034b50, true);
    local.setUint16(4, 20, true);
    local.setUint16(6, 0x0800, true);
    local.setUint16(8, 0, true);
    local.setUint16(10, dosTime, true);
    local.setUint16(12, dosDate, true);
    local.setUint32(14, crc, true);
    local.setUint32(18, size, true);
    local.setUint32(22, size, true);
    local.setUint16(26, name.length, true);

    var central = new DataView(new ArrayBuffer(46));
    central.setUint32(0, 0x02014b50, true);
    central.setUint16(4, 20, true);
    central.setUint16(6, 20, true);
    central.setUint16(8, 0x0800, true);
    central.setUint16(10, 0, true);
    central.setUint16(12, dosTime, true);
    central.setUint16(14, dosDate, true);
    central.setUint32(16, crc, true);
    central.setUint32(20, size, true);
    central.setUint32(24, size, true);
    central.setUint16(28, name.length, true);

    var end = new DataView(new ArrayBuffer(22));
    end.setUint32(0, 0x06054b50, true);
    end.setUint16(8, 1, true);
    end.setUint16(10, 1, true);
    end.setUint32(12, 46 + name.length, true);
    end.setUint32(16, 30 + name.length + size, true);

    return new Blob([local, name, bytes, central, name, end], { type: 'application/zip' });
  }

  function wrapInput(input) {
    var file = input.files[0];
    return file.arrayBuffer().then(function (buffer) {
      var zip = zipStore(file, new Uint8Array(buffer));
      var transfer = new DataTransfer();
      transfer.items.add(new File([zip], file.name + '.zip', { type: 'application/zip', lastModified: file.lastModified }));
      input.files = transfer.files;
    });
  }

  function submitNow(form, submitter) {
    form.__ssZipped = true;
    if (submitter && submitter.name) {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = submitter.name;
      hidden.value = submitter.value;
      form.appendChild(hidden);
    }
    HTMLFormElement.prototype.submit.call(form);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (e.defaultPrevented || !form || form.__ssZipped || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (typeof DataTransfer === 'undefined' || typeof TextEncoder === 'undefined' || !window.Blob || !Blob.prototype.arrayBuffer) return;

    var inputs = Array.prototype.filter.call(form.querySelectorAll('input[type="file"]'), function (input) {
      return input.files && input.files.length === 1 && IMAGE_FILE.test(input.files[0].name);
    });
    if (!inputs.length) return;

    e.preventDefault();
    var submitter = e.submitter;
    Promise.all(inputs.map(wrapInput))
      .catch(function () { /* Verpacken fehlgeschlagen: Original wie bisher hochladen */ })
      .then(function () { submitNow(form, submitter); });
  });
})();
